export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const PAST_DATE_RANGE = 'PAST_DATE_RANGE';